import { useEffect, useState } from 'react';
import { listBusinessRole } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useBusinessRole(practice_area = '') {
  const [List, setList] = useState([]);

  const loadBusinessRoles = () => {
    totalCountEvent('business_role').then((response) => {
      listBusinessRole(response.data, '', 'forward', false, practice_area).then((res) => {
        setList(res.data?.business_role);
      });
    });
  };

  useEffect(() => {
    loadBusinessRoles();
  }, [practice_area]);

  return { businessRoleList: List };
}
